import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { CounterEditPageRoutingModule } from './counter-edit-routing.module';

import { CounterEditPage } from './counter-edit.page';
import { IonicSelectableModule } from 'ionic-selectable';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    ReactiveFormsModule,
    CounterEditPageRoutingModule,
    IonicSelectableModule
  ],
  declarations: [CounterEditPage]
})
export class CounterEditPageModule {}
